let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9JgMv")).then(() => parcelRequire('bz3yf'));